import PropTypes from "prop-types"
import React, { useState, useRef, Fragment } from "react"

import Button from "@atoms/Button/Button"
import Heading from "@atoms/Heading/Heading"
import ModalWindow from "@atoms/ModalWindow/ModalWindow"
import CheckboxGroup from "@molecules/CheckboxGroup/CheckboxGroup"

const FiltersModal = ({ label, filters, onSave, onCheck }) => {
  const [isOpen, setIsOpen] = useState(false)
  const checkboxRefs = useRef([])

  const resetSelections = () =>
    checkboxRefs.current.forEach((ref) => ref.resetState())

  return (
    <>
      <button
        className={`rounded-full text-sm leading-3 font-medium text-blue-900 ${
          isOpen ? "bg-gray-100" : "bg-gray-50"
        } py-2.5 px-3.5 ring-blue-900 ring-inset hover:ring-2`}
        onClick={() => setIsOpen(true)}
      >
        {label}
      </button>

      <ModalWindow open={isOpen} setOpen={setIsOpen}>
        <Heading
          level={6}
          text="Lisää filtereitä"
          fontWeight="font-normal"
          customClasses="mb-5"
        />
        {filters?.map(
          ({ list, className, initialState, heading, groupName }, index) => (
            <Fragment key={`${heading}-${index}`}>
              <Heading level={3} text={heading} customClasses="mb-3.5" />
              <CheckboxGroup
                list={list}
                initialState={initialState}
                onCheck={onCheck}
                className={className}
                groupName={groupName}
                ref={(el) => (checkboxRefs.current[index] = el)}
              />
            </Fragment>
          )
        )}
        <div className="flex justify-end items-center pt-3 px-4 border-t border-solid border-gray-50">
          <Button variant="whiteBlue" action={resetSelections}>
            Tyhjennä
          </Button>
          <Button
            variant="blueWhite"
            action={() => {
              onSave()
              setIsOpen(false)
            }}
            margin="mr-0"
          >
            Tallenna
          </Button>
        </div>
      </ModalWindow>
    </>
  )
}

FiltersModal.propTypes = {
  label: PropTypes.string.isRequired,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      list: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
          label: PropTypes.string.isRequired,
        })
      ).isRequired,
      className: PropTypes.string,
      heading: PropTypes.string.isRequired,
      initialState: PropTypes.objectOf(PropTypes.bool.isRequired),
    })
  ).isRequired,
  onSave: PropTypes.func.isRequired,
  onCheck: PropTypes.func.isRequired,
}

export default FiltersModal
